function _createAnimationHandler(element, animationCompleteEventName, maxTime, validateEvent, callback) {
    var complete = false;
    var timeoutId = undefined;
    var onComplete = function (event) {
        if (complete || !validateEvent(event)) {
            return;
        }
        complete = true;
        if (timeoutId !== undefined) {
            window.clearTimeout(timeoutId);
            timeoutId = undefined;
        }
        if (element) {
            element.removeEventListener(animationCompleteEventName, onComplete);
        }
        callback();
    };
    if (sas.ltjs.isOpenUI) {
        jQuery.sap.require('sas.hc.ui.core.AnimationUtil');
        if (!sas.hc.ui.core.AnimationUtil.getVisualEffectsEnabled()) {
            maxTime = 0;
        }
    }
    if (!element) {
        maxTime = 0;
    }
    timeoutId = window.setTimeout(onComplete, maxTime);
    if (maxTime !== 0 && element) {
        element.addEventListener(animationCompleteEventName, onComplete);
    }
    return {
        cancel: onComplete,
    };
}
export function transitionComplete(element, propertyName, callback, maxTime) {
    if (!callback) {
        return null;
    }
    maxTime = maxTime || 300;
    var isOurTransitionEvent = function (e) {
        var event = e;
        if (event) {
            if (propertyName && event.propertyName !== propertyName) {
                return false;
            }
            var srcElement = event.srcElement || event.target;
            if (element && srcElement !== element) {
                return false;
            }
        }
        return true;
    };
    return _createAnimationHandler(element, 'transitionend', maxTime, isOurTransitionEvent, callback);
}
export function animationComplete(element, animationName, callback, maxTime) {
    if (!callback) {
        return null;
    }
    maxTime = maxTime || 300;
    var isOurAnimationEvent = function (e) {
        var event = e;
        if (event) {
            if (animationName && event.animationName !== animationName) {
                return false;
            }
            var srcElement = event.srcElement || event.target;
            if (element && srcElement !== element) {
                return false;
            }
        }
        return true;
    };
    return _createAnimationHandler(element, 'animationend', maxTime, isOurAnimationEvent, callback);
}
export function animate(container, property, value, callback, maxTime) {
    if (!container || !property) {
        return null;
    }
    container.style[property] = value;
    return transitionComplete(container, property, callback, maxTime);
}
